// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import FileDownloadSvg from '@rsuite/icon-font/lib/action/FileDownload';
var FileDownload = createSvgIcon({
  as: FileDownloadSvg,
  ariaLabel: 'file download',
  category: 'action',
  displayName: 'FileDownload'
});
export default FileDownload;